
<!-- Tool name -->
<span class="tool-label">
  {{ getToolLabel() | translate }}
</span>

<mat-divider [vertical]="true"></mat-divider>

<!-- Subtool selector (arrows, shapes, measures and text) -->
<div #subtoolElem *ngIf="selectedTool == EditorTool.ARROW || selectedTool == EditorTool.SHAPE || selectedTool == EditorTool.MEASURE || selectedTool == EditorTool.TEXT" class="subtool-selector">
  <div class="tool" (mouseenter)="openSubtoolSelectionDialog()">
    <mat-icon [class.text-icon]="selectedTool == EditorTool.TEXT" [ngStyle]="{ fontSize: getSubtoolIconSize() }">{{ getSubtoolIcon() }}</mat-icon>
  </div>
</div>

<!-- Color tool -->
<div #colorElem class="color-selector">
  <div class="tool" (mouseenter)="openColorSelectionDialog()">
    <div class="color" [ngStyle]="{ backgroundColor: getColor() }"></div>
  </div>
</div>

<!-- Width tool -->
<div #widthElem *ngIf="selectedTool == EditorTool.SHAPE || selectedTool == EditorTool.FREEHAND" class="width-selector">
  <div class="tool" (mouseenter)="openWidthSelectionDialog()">
    <div class="width" [ngStyle]="{ height: getWidth() }"></div>
  </div>
</div>


<!-- Selection panel -->
<div #selectionPanel *ngIf="showSelectionPanel" class="selection-panel" @fadeIn @fadeOut [ngStyle]="{ left: selectionPanelLeftOffset + 'px' }" (mouseleave)="closeSelectionDialog()">
  <ng-container [ngSwitch]="selectionPanelType">

    <ng-container *ngSwitchCase="EditorSelectionPanel.SUBTOOL">
      <div [ngSwitch]="selectedTool" class="title">
        <ng-container *ngSwitchCase="EditorTool.ARROW">{{ 'Select arrow' | translate }}</ng-container>
        <ng-container *ngSwitchCase="EditorTool.SHAPE">{{ 'Select shape' | translate }}</ng-container>
        <ng-container *ngSwitchCase="EditorTool.TEXT">{{ 'Font size' | translate }}</ng-container>
      </div>
      <div class="container">

        <div *ngFor="let subtool of getAllSubtools()" class="tool" [class.selected]="isCurrentSubtool(subtool)" (click)="setSubtool(subtool)">
          <mat-icon [class.text-icon]="selectedTool == EditorTool.TEXT" [ngStyle]="{ fontSize: getSubtoolIconSize(selectedTool, subtool) }">{{ getSubtoolIcon(selectedTool, subtool) }}</mat-icon>
        </div>

      </div>
    </ng-container>

    <ng-container *ngSwitchCase="EditorSelectionPanel.COLOR">
      <div class="title">{{ 'Select color' | translate }}</div>
      <div class="container">

        <div *ngFor="let color of getAllColors()" class="tool" [class.selected]="isCurrentColor(color)" (click)="setColor(color)">
          <div class="color" [ngStyle]="{ backgroundColor: color }"></div>
        </div>

      </div>
    </ng-container>

    <ng-container *ngSwitchCase="EditorSelectionPanel.WIDTH">
      <div class="title">{{ 'Select width' | translate }}</div>
      <div class="container">

        <div *ngFor="let width of getAllWidths()" class="tool" [class.selected]="isCurrentWidth(width)" (click)="setWidth(width)">
          <div class="width" [ngStyle]="{ height: getWidth(width), width: '100px' }"></div>
        </div>

      </div>
    </ng-container>

  </ng-container>
</div>
